/**
 * 模拟的React Hooks
 * ```
 * 只是长得像
 * ```
 * @author  Jerry <superzcj_001@163.com>
 * @since   2022-09-05 13:45:32
 * @update  2023-12-18 14:17:57
 */
import { computed, isRef, ref, toRef, triggerRef } from 'vue';

const isValueNotFunction = (arg) => typeof arg !== 'function';

export const useState = (initialState) => {
  const state = isRef(initialState) ? toRef(initialState) : ref(initialState);

  const setState = (newState, options) => {
    state.value = isValueNotFunction(newState) ? newState : newState(state.value);
    if (options?.equals === false) {
      triggerRef(state);
    }
  };

  return [state, setState];
}

export const useMemo = computed;
